import type { RouteLocation, RouteLocationNormalized, RouteLocationRaw } from '#vue-router'

async function redirectFromPage(to: RouteLocationNormalized, path: string) {
    const navigateObject: RouteLocationRaw = {
        path,
        query: {
            ...to.query,
        },
    }

    return navigateTo(navigateObject, {
        redirectCode: 302,
    })
}

/** Where this middleware redirects `to` during SSR, if anywhere; `isRedirectPredicted` asks it too. */
export function landingPageRedirect(to: Pick<RouteLocation, 'name' | 'query'>, isExisting: boolean): string | undefined {
    // Allow GTM debugging to always go to landingpage
    if ('gtm_debug' in to.query) {
        return
    }

    // # Begin DGA block:landingPageRedirect
    if (isExisting) {
        switch (to.name) {
            case 'bingo':
                return '/bingo-lobby'

            case 'allslots':
                return '/slots-lobby'

            case 'index':
                return '/lobby'
        }

        return
    }

    switch (to.name) {
        case 'bingo-lobby':
            return '/bingo'

        case 'slots-lobby':
            return '/allslots'

        case 'lobby':
            return '/'
    }
    // # End DGA block
}

export default defineNuxtRouteMiddleware((to) => {
    const { isExisting } = useUserInfo()
    const path = import.meta.server ? landingPageRedirect(to, isExisting.value) : undefined

    if (path) return redirectFromPage(to, path)
})
